import { PUBLIC_ROUTES, ROUTES } from '../constants';

/**
 * Checks if the given pathname is a public route that doesn't require authentication.
 * Matches exact path or any sub-routes (e.g., '/login' matches '/login/sso-login').
 *
 * @param pathname - The pathname to check
 * @returns true if the pathname is a public route
 */
export const isPublicRoute = (pathname: string): boolean => {
  return PUBLIC_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  );
};

/**
 * Builds a login URL with a 'next' parameter to redirect back after authentication.
 *
 * @param returnPath - The path to redirect to after login (will be URI encoded)
 * @param basePath - Optional custom login path (defaults to ROUTES.login)
 * @returns The login URL with the next parameter
 */
export const buildLoginRedirectUrl = (
  returnPath: string,
  basePath: string = ROUTES.login,
): string => {
  const separator = basePath.includes('?') ? '&' : '?';
  return `${basePath}${separator}next=${encodeURIComponent(returnPath)}`;
};
